module.exports = __webpack_public_path__ + "static/media/ai-ad-massie-thumbnailMOBILE.b0b02899.jpg";